import { Badge } from '../ui/badge';
import { Shield, ShieldAlert, ShieldX } from 'lucide-react';

interface RiskScoreBadgeProps {
  score: number;
  maxScore?: number;
}

const RiskScoreBadge = ({ score, maxScore = 10 }: RiskScoreBadgeProps) => {
  const getRiskLevel = () => {
    const percentage = (score / maxScore) * 100;
    if (percentage <= 33) return 'low';
    if (percentage <= 66) return 'medium';
    return 'high';
  };

  const getRiskColor = () => {
    const level = getRiskLevel();
    switch (level) {
      case 'low':
        return 'bg-green-100 text-green-800';
      case 'medium':
        return 'bg-yellow-100 text-yellow-800';
      case 'high':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getRiskIcon = () => {
    const level = getRiskLevel();
    switch (level) {
      case 'low':
        return <Shield className="h-3 w-3 mr-1" />;
      case 'medium':
        return <ShieldAlert className="h-3 w-3 mr-1" />;
      case 'high':
        return <ShieldX className="h-3 w-3 mr-1" />;
      default:
        return null;
    }
  };

  return (
    <Badge className={getRiskColor()}>
      {getRiskIcon()}
      Risk: {getRiskLevel().toUpperCase()} ({score}/{maxScore})
    </Badge>
  );
};

export default RiskScoreBadge;
